const PlatePad = (str) => {
    let len = str.length;
    let part = str.slice(len - 3, len);
    return "****" + part;
  };

  export default PlatePad